<template>
  <div :class="$style.box">
    <SectionTitle :class="$style.box__title">
      病名から引受目安を検索
    </SectionTitle>
    <form @submit.prevent="search" :class="$style.box__form">
      <label>病名</label>
      <DolphinTextInput
        :class="$style.search__input"
        placeholder="例) 胃がん"
        v-model="diseaseInput"
        name="disease"
      />
      <FlatButton type="submit" :class="$style.search__submit" size="medium">
        検索
      </FlatButton>
    </form>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  modelValue: string
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void
}>()

const modelValue = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})

const diseaseInput = ref('')

const router = useRouter()

const search = () => {
  modelValue.value = diseaseInput.value

  // eslint-disable-next-line fp/no-mutating-methods
  router.push({ name: 'solicitorCloud' })
}
</script>

<style lang="scss" module>
.box {
  padding: 20px 0;
  border-radius: 10px;
  width: 100%;
  background-color: $color-surface-primary;

  &__title {
    font-size: 16px;
    padding: 0 20px;
  }

  &__form {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    padding: 20px 20px 0;
    border-top: 1px solid $color-border-low-emphasis;

    & > *:nth-child(n + 2) {
      margin-top: 10px;
    }

    label {
      font-weight: bold;
    }
  }
}
</style>
